var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9738 26.5464C32.4995 26.0472 32.918 25.4462 33.2042 24.7801C33.4901 24.114 33.6379 23.3966 33.6379 22.6717C33.6379 21.9467 33.4901 21.2294 33.2042 20.5632C32.918 19.8971 32.4995 19.2962 31.9738 18.797C30.8979 17.7757 29.4708 17.2063 27.9872 17.2063C26.5036 17.2063 25.0767 17.7757 24.0006 18.797L20 22.7976L15.9994 18.797C14.9234 17.7757 13.4964 17.2063 12.0128 17.2063C10.5292 17.2063 9.10226 17.7757 8.02622 18.797C7.50052 19.2962 7.08194 19.8971 6.79588 20.5632C6.50982 21.2294 6.3623 21.9467 6.3623 22.6717C6.3623 23.3966 6.50982 24.114 6.79588 24.7801C7.08194 25.4462 7.50052 26.0472 8.02622 26.5464L20 38.1844L31.9738 26.5464Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.0059C23.0902 13.0059 25.5953 10.5008 25.5953 7.41067C25.5953 4.3205 23.0902 1.81543 20 1.81543C16.9099 1.81543 14.4048 4.3205 14.4048 7.41067C14.4048 10.5008 16.9099 13.0059 20 13.0059Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/Healthcare.00bb34f522196b807c3bafd09c925745.svg";
export { ForwardRef as ReactComponent };